module.exports = __webpack_public_path__ + "static/media/CanteenSmartShopper.6bd1f6ff.png";